import { StdResponse, coreAxios, monixAxios } from "@/declare/api/axios"
import { AxiosResponse } from "axios";
import qs from "qs";
import { MonitorObjectPrimitive } from "../interface/primitive";

/**
 * 获取指定图形中的所有图元
 * @param projectUuid 图形唯一标识
 * @returns Promise 解析为 AxiosResponse，包含图元列表
 */
export function findPrimitivesInProject(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/primitives`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 查找项目中的所有块模板列表
 * @param projectUuid 
 * @param params 
 * @returns 
 */
export function findBlocksInProject(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/blocks`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 获取图层列表
 * @param projectUuid 
 * @param params 
 * @returns 
 */
export function findLayersInProjectUuid(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/layers`, {
        params: {
            ...params,
        }
    })
}